var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 425.6 287.1",
    style: {
      enableBackground: "new 0 0 425.6 287.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#525355;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.4,1C10,1,0,11,0,23.4s10,22.4,22.4,22.4h380.8c12.4,0,22.4-10,22.4-22.4S415.6,1,403.2,1H22.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.4,121.2C10,121.2,0,131.2,0,143.6S10,166,22.4,166h380.8c12.4,0,22.4-10,22.4-22.4s-10-22.4-22.4-22.4 L22.4,121.2L22.4,121.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.4,242.3C10,242.3,0,252.3,0,264.7c0,12.4,10,22.4,22.4,22.4h380.8c12.4,0,22.4-10,22.4-22.4 s-10-22.4-22.4-22.4L22.4,242.3L22.4,242.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.c257bebff605f08acab50e87f9c5bcb2.svg";
export { ForwardRef as ReactComponent };